import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-filtro-apagar-comunicacao-indevida',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss']
})
export class FiltroApagarComunicacaoIndevidaComponent implements OnInit{
   @Output() onFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output() onOpen: EventEmitter<any> = new EventEmitter<any>();
  searchForm: FormGroup;
  protocolo: string = '';
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.criarFormulario();

    const sessaoFiltro = JSON.parse(sessionStorage.getItem('filtro'));

    if(sessionStorage.getItem('filtro') && sessaoFiltro.protocolo){
      this.searchForm.get('protocolo').setValue(sessaoFiltro.protocolo);
    } else {
      this.searchForm.get('protocolo').setValue('');
    }
  }

  criarFormulario() {
    this.searchForm = this.fb.group({
      protocolo: '',
    });
  }

  pesquisarProtocolo() {
    this.onFilter.emit(this.searchForm.value);
    // this.searchForm.reset();
  }
}
